import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GetJson } from '@awp/helpers/fetchReact';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { STATE_STATUS, REST_API, FORM_MODE } from '@awp/constants';
import {
  setUserPreset,
  setSaveUserPresetStatus,
  selectedUserPreset,
  saveUserPreset,
  getSaveUserPresetStatus,
} from '@stores/userPresetSlice';
import MultiSelectCheckbox from '@awp/components/Common/DropDown/Multiselect/MultiselectCheckbox';
import AwpYesNoDialog from '@awp/components/Common/AwpYesNoDialog';
import { Crud } from '@awp/shared/Crud';

const UserPresetModal = ({ visible, mode, deletePreset, closeModal }) => {
  const dispatch = useDispatch();
  const preset = useSelector(selectedUserPreset);
  const saveUserPresetStatus = useSelector(getSaveUserPresetStatus);
  const [observationTypes, setObservationTypes] = useState([]);
  const [observationTypeOptions, setObservationTypeOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [selectedOptionError, setSelectedOptionError] = useState(null);
  const [presetName, setPresetName] = useState('');
  const [presetError, setPresetError] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const title =
    mode === FORM_MODE.EDIT
      ? 'Update User Preset'
      : mode === FORM_MODE.CREATE
      ? 'Create Dataset Filter'
      : 'Dataset Filter';

  const crud = new Crud(title);

  useEffect(() => {
    if (preset) setPresetName(preset.Name);
    if (visible) {
      const url = REST_API.OBSERVATION_TYPES_USED_BY_SEGMENTS;
      GetJson(url)
        .then((response) => response.json())
        .then((data) => {
          let _allOptions = [];
          if (data && data.length > 0) {
            setObservationTypes(data);
            data.map((t) => {
              _allOptions.push({ value: t.ObservationTypeId, label: t.ObservationTypeDisplayName });
            });
          }
          setObservationTypeOptions(_allOptions);
          if (
            _allOptions &&
            _allOptions.length > 0 &&
            preset &&
            preset.ObservationTypes &&
            preset.ObservationTypes.length > 0
          ) {
            let ots = getSelectedOptions(_allOptions);
            if (ots) setSelectedOptions([...ots]);
          }
        });
    }
  }, [visible, preset]);

  const handleClose = () => {
    setPresetName('');
    setShowDeleteConfirm(false);
    setPresetError(null);
    setSelectedOptions(null);
    setSelectedOptionError(null);
    setObservationTypeOptions([]);
    dispatch(setUserPreset(null));
    closeModal();
  };

  const onChangeObs = (value) => {
    if (
      (!selectedOptions || selectedOptions.length === 0) &&
      (!value || !value[0] || !value[0].value || value[0].value < 1)
    ) {
      return setSelectedOptionError('Observation Type is required.');
    }
    setSelectedOptionError(null);
    setSelectedOptions(value);
  };
  const onBlurObs = () => {
    if (!selectedOptions || selectedOptions.length === 0) {
      return setSelectedOptionError('Observation Type is required.');
    }
  };
  const getSelectedOptions = (allOptions) => {
    if (
      !preset ||
      !preset.ObservationTypes ||
      preset.ObservationTypes.length === 0 ||
      !allOptions ||
      allOptions.length === 0
    )
      return null;

    const observationTypeIds = preset.ObservationTypes.map((obs) => obs.ObservationTypeId + '');
    return allOptions.filter((v) => observationTypeIds.includes(v.value + ''));
  };
  const getSelectedObservationTypes = () => {
    if (!selectedOptions || selectedOptions.length === 0) return null;
    const observationTypeIds = selectedOptions.map((obs) => obs.value + '');
    return observationTypes.filter((v) => observationTypeIds.includes(v.ObservationTypeId + ''));
  };

  const onChangePreset = (e) => {
    e.preventDefault();
    if (isValueEmpty(presetName) && (!e || !e.target || isValueEmpty(e.target.value))) {
      setPresetError('Preset Name is required.');
      return;
    }
    setPresetName(e.target.value);
    setPresetError(null);
  };
  const handleSubmit = () => {
    let _selectedObservationTypes = getSelectedObservationTypes();
    let isFailed = false;
    if (isValueEmpty(presetName)) {
      isFailed = true;
      setPresetError('Preset Name is required.');
    }
    if (!_selectedObservationTypes || _selectedObservationTypes.length < 1) {
      isFailed = true;
      setSelectedOptionError('Observation Type is required.');
    }
    if (isFailed) return;
    const presetDto = {
      ...preset,
      Name: presetName,
      ObservationTypes: _selectedObservationTypes,
    };
    if (mode === FORM_MODE.EDIT) {
      setSaveUserPresetStatus(STATE_STATUS.LOADING);
      dispatch(setUserPreset(presetDto));
      dispatch(saveUserPreset())
        .then((response) => {
          if (response) {
            const msg = response.payload;
            if (msg && msg.error) {
              if (msg.error['name']) setPresetError(msg.error['name']);
            } else {
              handleClose();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSaveUserPresetStatus(STATE_STATUS.LOADING);
      dispatch(setUserPreset(presetDto));
      dispatch(saveUserPreset())
        .then((response) => {
          if (response) {
            const msg = response.payload;
            if (msg && msg.error) {
              if (msg.error['name']) setPresetError(msg.error['name']);
            } else {
              handleClose();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const onClickDelete = () => {
    setShowDeleteConfirm(true);
  };
  return (
    <Modal show={visible} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>{crud.getModalTitle()}</Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={10}>
            <Form.Group>
              <Form.Label>
                <b>Filter Name </b>
              </Form.Label>
              <br />
              <Form.Control
                name="presetName"
                id="presetName"
                className="text-input"
                onChange={onChangePreset}
                onBlur={onChangePreset}
                maxLength="50"
                autoComplete="off"
                defaultValue={presetName ? presetName : ''}
                placeholder=""
              />
              {presetError && (
                <div className="text-danger mt-1">
                  <ul>
                    <li key={1}>{presetError}</li>
                  </ul>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <Form.Group>
              <Form.Label>
                <b>Select Observation Type </b>
              </Form.Label>
              <br />
              {observationTypeOptions && (
                <MultiSelectCheckbox
                  options={observationTypeOptions || []}
                  value={selectedOptions || []}
                  onChange={onChangeObs}
                  onBlur={onBlurObs}
                  isClearable={true}
                  placeholder={'Select...'}
                />
              )}
              {selectedOptionError && (
                <div className="text-danger mt-1">
                  <ul>
                    <li key={1}>{selectedOptionError}</li>
                  </ul>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={
            isValueEmpty(observationTypeOptions) ||
            selectedOptionError ||
            presetError ||
            saveUserPresetStatus === STATE_STATUS.LOADING
          }
          onClick={handleSubmit}
        >
          Save
        </Button>
        {!showDeleteConfirm && mode === FORM_MODE.EDIT ? (
          <Button
            className="ml-4"
            variant="danger"
            disabled={saveUserPresetStatus === STATE_STATUS.LOADING}
            onClick={() => {
              onClickDelete();
            }}
          >
            Delete
          </Button>
        ) : preset && mode === FORM_MODE.EDIT ? (
          <AwpYesNoDialog
            action={() => {
              deletePreset(preset.Id);
              handleClose();
            }}
            setShowYesNoConfirm={setShowDeleteConfirm}
            props={{}}
          />
        ) : (
          <></>
        )}
      </Modal.Footer>
    </Modal>
  );
};

UserPresetModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default UserPresetModal;
